import http from '../utils/httpRequest';

const syscheckitemconfigSave = (params) => {
    return http.post('/superviseConfig/save', { ...params },{baseURL:baseURL})
}
const syscheckitemconfigDelete = (params) => {
    return http.post('/superviseConfig/delete',{ ...params } ,{baseURL:baseURL})
}
const updateStatusById = (params) => {
    return http.post('/superviseConfig/updateStatus',{ ...params }, {baseURL:baseURL})
}
const syscheckitemconfigList = (params) => {
    return http.post('/superviseConfig/list', { ...params },{baseURL:baseURL})
}
const syscheckitemconfigSingle = (params) => {
    return http.get('/superviseConfig/get?id='+params,{baseURL:baseURL})
}



export {
    updateStatusById,// 更新开启状态
    syscheckitemconfigList,//列表
    syscheckitemconfigSave,//保存
    syscheckitemconfigDelete,//删除
    syscheckitemconfigSingle,//单个查询
}